<template lang="pug">
div
  .text-editor
    froala(id="edit" :tag="'textarea'" :config="config" v-model="form" @focus="" ref="editor")
    .button-container
      v-btn.button-sm.mr-2(@click="showAttachDialog = true" depressed) {{ $t('attach_photo') }}
      v-btn.button-sm(color="neutral700" depressed dark :loading="isLoading" @click="$emit('onSave')") {{ $t('save') }}
  attach-photo-dialog(v-if="showAttachDialog" :open.sync="showAttachDialog" @onUpload="onUploadPhoto")
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
FroalaEditor.DefineIcon('moreText',{SVG_KEY: 'more'})

import AttachPhotoDialog from '@/components/clinic/dialogs/AttachPhotoDialog.vue'
 
export default {
  name: 'TextEditor',
  props: ['parentForm', 'isLoading', 'height'],
  components: { AttachPhotoDialog },
  data: (vm) => ({
    config: {
      events: {
        'image.beforeUpload' () {
          return false
        },
      },
      key: process.env.VUE_APP_FROALA_API_KEY,
      attribution: false,
      scrollableContainer: '#edit',
      codeBeautifierOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      toolbarBottom: true,
      toolbarButtons: {
        'moreText': {
          buttons: ['bold', 'italic', 'underline', 'formatUL', 'undo', 'redo'],
          'buttonsVisible': 7
        }
      },
      quickInsertEnabled: false,
      imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
      imageEditButtons: ['imageCaption', 'imageRemove', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
      imageResizeWithPercent: true,
      fontSize: ['8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
      paragraphFormat: {
        N: 'Normal',
        H1: 'Heading 1',
        H2: 'Heading 2',
        H3: 'Heading 3',
        H4: 'Heading 4',
      },
      toolbarSticky: false,
      height: vm.height,
      charCounterCount: false,
    },
    showAttachDialog: false,
  }),
  computed: {
    form: {
      get () {
        return this.parentForm
      },
      set (newValue) {
        this.$emit('update:parentForm', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    onUploadPhoto (photos) {
      for (const i in photos) {
        const photo = photos[i]
        this.insertPhoto(photo)
      }
    },
    insertPhoto (photo) {
      const editor = this.$refs?.editor?.$el['data-froala.editor']
      if (editor) {
        let photoUrl = photo.file
        photoUrl = photoUrl.replace('https://cdn.yezza.io', 'https://img.yezza.io/full-fit-in')
        editor.image.insert(photoUrl, null, { 'name': photo.filename, 'id': photo.hid }, null, null)
      }
    },
  }
}
</script>

<style lang="scss" scoped>

::v-deep .fr-box.fr-basic .fr-wrapper {
  border: none !important;
}

::v-deep .fr-toolbar {
  border: none !important;
}

::v-deep .fr-box .fr-counter {
  visibility: hidden !important;
}

::v-deep p {

  margin-bottom: 0px !important;
}

::v-deep ul, ol {
  padding-left: 0px;
}

::v-deep li {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 24px !important;
  line-height: 24px !important;
}


::v-deep .fr-box.fr-basic .fr-element.fr-view {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 24px !important;
  line-height: 24px !important;
  color: #000000;
}

.button-container {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 280px;
  margin-bottom: 6px;
}

.text-editor {
  position: relative;
}
</style>

